export default __webpack_public_path__ + "static/mtns-f80797e4a0f63a7d676ba24296408bb0.jpg";